<script setup>
import PageWrapper from '@/components/shared/page/PageWrapper.vue'
import ChatInterface from '@/components/chat/ChatInterface.vue'
import {useMessaging} from '@/composables/use-messaging.js'
import {useNavigation} from '@/composables/use-navigation.js'
import {useErrorHandling} from '@/composables/use-error-handling.js'
import {useEnrollmentByCode} from '@/composables/use-enrollment-by-code.js'
import {ref, onMounted} from 'vue'

//Composables
const messages = ref([])
const {appendOutgoingMessage} = useMessaging(messages)
const {processError} = useErrorHandling()
const {enrollByCode} = useEnrollmentByCode()
const {goToHome, goToConversationForEnrollment} = useNavigation()

//User message handler
const processUserMessage = async message => {
  appendOutgoingMessage(`Thanks, please wait while we validate your code`, {
    isReply: true,
  })
  try {
    const enrollment = await enrollByCode(message)
    if (enrollment) {
      appendOutgoingMessage(`Your enrollment was successful! We’ll redirect you to the new course now...`, {
        isReply: true,
        delay: 2500,
      })
      setTimeout(() => goToConversationForEnrollment(enrollment), 5000)
    }
    else {
      throw new Error('Enrollment not found by code')
    }
  }
  catch (error) {
    processError(error)
    appendOutgoingMessage(`Sorry, we couldn’t find a course with that code. Please try again.`, {
      isReply: true,
      delay: 2500,
    })
  }
}

//On mount, create initial message
onMounted(() => {
  appendOutgoingMessage(`Please enter a course sign-up code to enroll`, {
    isReply: true,
  })
})
</script>

<template>
  <PageWrapper
    header="Enroll in a new course"
    is-fixed-height
    can-go-back
    @back="goToHome()"
  >
    <ChatInterface
      :messages="messages"
      :is-chat-disabled="messages.length === 0"
      @message="processUserMessage($event.message)"
    />
  </PageWrapper>
</template>
